import React, { ReactNode, useContext } from 'react';
import classNames from 'classnames';
import './Button.scss';
import { ThemeContext } from '../../store/ThemeProvider';
import { alpha, getPendantColor } from '../../utils/color';

export interface IButton {
  children: ReactNode;
  className?:string;
  onClick?: () => void;
  type?: string;
  style?: React.CSSProperties;
  size?: string;
  radius?: boolean;
  useTheme?: boolean; // 是否使用主题色，默认是需要使用
}

const Button = (props: IButton) => {
  const { mainColor, h1Color, componentColor } = useContext(ThemeContext);
  let style = props.style || {};
  // 背景为主文本色时，文字统一用组件色
  if (props.useTheme !== false) {
    style.backgroundColor = mainColor;
    let [forecolor, backcolor] = getPendantColor(mainColor);
    style.color = alpha(backcolor, 1);
  }
  return (
    <button
      className={classNames(
        'button',
        props.type || 'primary',
        'btn-size-' + (props.size || 'middle'),
        props.className || '',
        {
          radius: props.radius
        }
      )}
      style={style}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};

export default Button;
